<template>
  <transition
    enter-active-class="dwp-transition dwp-ease-out dwp-duration-100"
    enter-class="dwp-transform dwp-opacity-0"
    enter-to-class="dwp-transform dwp-opacity-100"
    leave-active-class="dwp-transition dwp-ease-in dwp-duration-75"
    leave-class="dwp-transform dwp-opacity-100"
    leave-to-class="dwp-transform dwp-opacity-0"
  >
    <div
      v-if="isOpen"
      class="dwp-antialiased dwp-overflow-auto dwp-font-sans dwp-fixed dwp-px-4 dwp-pb-12 dwp-inset-0 sm:dwp-p-0 dwp-flex dwp-items-center dwp-justify-center"
    >
      <div class="dwp-fixed dwp-inset-0 dwp-transition-opacity" @click="isOpen = false">
        <div class="dwp-absolute dwp-inset-0 dwp-bg-gray-600 dwp-opacity-75"></div>
      </div>

      <SupportLinks v-if="supportLinks" />

      <div class="dwp-m-auto dwp-w-full">
        <div
          class="dwp-bg-white sm:dwp-my-16 dwp-m-auto dwp-rounded dwp-px-4 dwp-pt-5 dwp-pb-4 dwp-shadow-xl dwp-transform dwp-transition-all sm:dwp-p-10"
          :class="widthClass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="dwp-block dwp-absolute dwp-top-0 dwp-right-0 dwp-pt-4 dwp-pr-4">
            <button
              @click="isOpen = false"
              type="button"
              class="dwp-text-gray-400 hover:dwp-text-gray-500 focus:dwp-outline-none focus:dwp-text-gray-500 dwp-transition dwp-ease-in-out dwp-duration-150"
              aria-label="Close"
            >
              <svg class="dwp-h-6 dwp-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    open: Boolean,
    size: String,
    supportLinks: Boolean
  },
  components: {
    SupportLinks: () => import("@/components/SupportLinks.vue")
  },
  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(val) {
        return this.$emit("update:open", val);
      }
    },

    widthClass() {
      switch (this.size) {
        case "small":
          return "sm:dwp-max-w-md dwp-w-full";
          break;
        case "large":
          return "sm:dwp-max-w-3xl dwp-w-full";
          break;
        default:
          return "sm:dwp-max-w-lg dwp-w-full";
          break;
      }
    }
  }
};
</script>